module.exports = __webpack_public_path__ + "static/location-0548ffada35e486184096340558f4d4b.png";